function normalizeHtml(value) {
  return typeof value === 'string' ? value : ''
}

function clearEditorSelection(editor) {
  if (!editor || editor.isDestroyed) return

  try {
    editor.deselect?.()
  } catch (error) {
    // The old Slate document may already be gone. The replacement below
    // establishes a valid document and selection again.
  }

  try {
    editor.blur?.()
  } catch (error) {
    // A detached editor has no focusable DOM node. Content still needs to sync.
  }
}

export function syncExternalEditorValue({
  editor,
  currentHtml,
  nextHtml,
  apply,
}) {
  const normalizedHtml = normalizeHtml(nextHtml)
  if (normalizedHtml === normalizeHtml(currentHtml)) return false

  clearEditorSelection(editor)
  apply(normalizedHtml)
  return true
}
